module.exports = __webpack_public_path__ + "img/rsini_3.92f9e198.jpg";